// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { v4 } from "uuid";

export const uuid = (): string => v4();
